export default "__VITE_ASSET__$T4Vgt2Y__"